import React from 'react';
import { Apply } from '../pages/apply/Apply';
import { ApplyComplete } from '../pages/apply/ApplyComplete';
const routes = [
    {
        path: '/',
        exact: true,
        children: React.createElement(Apply, null),
        component: Apply,
    },
    {
        path: '/complete',
        children: React.createElement(ApplyComplete, null),
        exact: true,
        component: ApplyComplete,
    },
];
export default routes;
